import React, { useState, useEffect, useRef, useMemo } from 'react'
import { Modal } from 'react-bootstrap';
import LoadingAlert from '../../components/Alerts/LoadingAlert';
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import Keyboard from '../../components/Keyboard/Keyboard';
import VendingDispensed from './VendingDispensed';
import Vendingoutservice from './Vendingoutservice';
import VendingModalConfirmation from './VendingModalConfirmation';
import Socket from '../../utils/Socket.config';
import { Button } from 'react-bootstrap'
import { PaymentComunicationFetchAPI } from '../../api/PaymentComunication';
import { PaymentMethodFetchAPI } from '../../api/Paymentpost/PaymentMethod'
import { DiscountFetchAPI } from '../../api/Discounts';
import { MachinesFetchAPI } from '../../api/Machines';
import { PositionFetchAPI } from '../../api/Position';
import { FilterOrderFetchAPI } from '../../api/Paymentpost/FilterOrder';
import { AuthDgiFetchAPI } from '../../api/Paymentpost/AuthDgi';
import { OrderNumberFetchAPI } from '../../api/Paymentpost/OrderNumber';
import { DivicesFechtAPI } from '../../api/Divices';
import { VendingFetchAPI } from '../../api/LocalRequest/Vending';
import { RenderIf } from '../../components/utils/RenderIf';
import { RequestLocalFetchAPI } from '../../api/Paymentpost/RequestLocal';
import { OrdersFetchAPI } from '../../api/Orders';
import { OrderReturnFetchAPI } from '../../api/Paymentpost/OrderReturn';
import { YappyFetchAPI } from '../../api/Paymentpost/Yappy';
import { WhatsappFetchAPI } from '../../api/Whatsapp';
import { VendingSnakkyFetchAPI } from '../../api/LocalRequest/VendingSnakky';
import { VendingAndroidFetchAPI } from '../../api/LocalRequest/VendingAndroid';
import ModalCupon from './ModalCupon';
import VendingModalYappy from './VendingModalYappy';
import ModalYappyQr from './ModalYappyQr';
import oledComunication from './OledComunication';
import Swal from 'sweetalert2';
import { CouponPosFetchAPI } from '../../api/Paymentpost/Coupon';
import checkImg from './img/check.gif'
import errorImg from './img/error.gif';
import loadingImg from './img/loading.gif'
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';

function VendingMetPayments({ showModalPayment, setShowModalPayment, shoppingCart, invoiceTotal, invoiceTotalItbms, invoiceSubtotal, invoiceTotalDiscount, dataClient, setDataClient, setShoppingCart, setShowModalShopingCart, setEventHandlerShoppingCart, setEventHandlerMenu, setStatusScreen, statusComunicationVending, calculateInvoiceTotals, groups, taxesArrayAll, orderNumber, setOrderNumber, payments, setPayments, oledScreenPayments, getTemp, setAtivityTimer }) {
  const [showModalCupon, setShowModalCupon] = useState(false);
  const [displayKeyboard, setDisplayKeyboard] = useState('')
  const [item, setItem] = useState({ name: "", price: "", img: "" })
  const [data, setData] = useState({ name: "No registrado", ruc: "0-000-00", dv: "00" });
  const [paymentApproval, setPaymentApproval] = useState({ status: 0, description: "Procesando pago" })
  const [showModalDispense, setShowModalDispense] = useState(false);
  const [showModalPaymentProcess, setShowModalPaymentProcess] = useState(false);
  const [dataParamsPaymentVoucher, setDataParamsPaymentVoucher] = useState({ authorizationNumber: "", referenceNumber: "", systemTraceNumber: "" })
  const [dataInfoPaymentSelect, setDataInfoPaymentSelect] = useState({})
  const [showModalDatos, setShowModalDatos] = useState(false);
  const [showModaloutService, setShowModaloutService] = useState(false)
  const [paymentSelect, setPaymentSelect] = useState("")
  const [showModalYappy, setShowModalYappy] = useState(false);
  const [dataNoteCredit, setDataNoteCredit] = useState(false);
  const [dataRutaQr, setDataRutaQr] = useState("");
  const [showModalConfirmation, setShowModalConfirmation] = useState(false)
  const [newOrderTemperatureReady, setNewOrderTemperatureReady] = useState(false);
  const [newOrderTemperatureChecking, setNewOrderTemperatureChecking] = useState(false);
  const [itemReadyDispense, setItemReadyDispense] = useState([]);
  const [voucher_Order, setVoucher_Order] = useState({});
  const [order_code_register, setOrder_code_register] = useState("")
  const [transaction_code_register, setTransaction_code_register] = useState("")
  const [eventDispense, setEventDispense] = useState(0);
  const [title, setTitle] = useState("Ingrese el RUC");
  const [statusError, setStatusError] = useState(false);
  const [ready, setReady] = useState(false);
  const [selectPaymentYappy, setSelectPaymentYappy] = useState({})
  const [modalYappyQr, setModalYappyQr] = useState(false);
  const [dataYappy, setDataYappy] = useState({});
  const [dataHash, setDataHash] = useState("");
  const [statusRequestYappy, setStatusRequestYappy] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState({ payment: "", payment_id: 0, payment_data: {} })
  const [cupons, setCupons] = useState([]);
  const [discounts, setDiscounts] = useState([]);
  const [randomnumberRemoteValid, setRandomnumberRemoteValid] = useState("");
  const [typePaymentSelect, setTypePaymentSelect] = useState("");

  // ============================================================
  // PAYMENT METHODS PAGINATION (vmpm)
  // ============================================================
  const [paymentPage, setPaymentPage] = useState(0);
  const [paymentGridConfig, setPaymentGridConfig] = useState({ cols: 3, rows: 2 });
  const paymentTouchStartX = useRef(null);

  let token = localStorage.getItem('x-access-token');
  let machine = JSON.parse(localStorage.getItem('machine_vending'))
  let branchoffice = JSON.parse(localStorage.getItem('branchoffice_vending'));
  let business = JSON.parse(localStorage.getItem('business_vending'));


  const [showImg, setShowImg] = useState(false);

  const handleCloseImg = () => setShowImg(false);
  const handleShowImg = () => setShowImg(true);

  const inputRefLog = useRef(null);
  const inputRefLogYappy = useRef(null);
  const inputRefLogDispensed = useRef(null);
  const inputConfirmation = useRef(null);

  // Correlacion del pago remoto por pinpad: identifica de punta a punta el intento de pago
  // en curso (remote_payment_id del backend) para no depender solo de la conexion de socket.
  const remotePaymentIdRef = useRef(null);
  const processedRemotePaymentIdRef = useRef(null);
  const remotePaymentFallbackTimeoutRef = useRef(null);
  const remotePaymentFallbackAttemptsRef = useRef(0);
  const paymentInfoRef = useRef(paymentInfo);
  const typePaymentSelectRef = useRef(typePaymentSelect);
  // Un solo intento de fallback (produccion, 2026-09-08) dejo la maquina pegada para siempre
  // cuando ese intento unico tambien fallo (token vencido, blip de red, etc). Con reintentos
  // acotados, una falla transitoria del propio poll de recuperacion ya no es un callejon sin salida.
  const REMOTE_PAYMENT_FALLBACK_INITIAL_DELAY_MS = 30000;
  const REMOTE_PAYMENT_FALLBACK_RETRY_DELAY_MS = 15000;
  const REMOTE_PAYMENT_FALLBACK_MAX_ATTEMPTS = 4;

  useEffect(() => { paymentInfoRef.current = paymentInfo; }, [paymentInfo]);
  useEffect(() => { typePaymentSelectRef.current = typePaymentSelect; }, [typePaymentSelect]);

  // El listener de socket de updatedRemotePinPadPayment vive dentro de un useEffect que solo
  // depende de showModalPayment (a proposito, para no reconectar el socket a mitad de pago - ver
  // el useEffect mas abajo). Eso significa que su closure (y por lo tanto registerOrder, llamado
  // desde alli) queda "congelado" con los props de facturacion tal como estaban en el render en
  // que showModalPayment paso a true por ultima vez. Como Total/itbms/taxes/subtotal se calculan
  // de forma asincrona (useEffect([shoppingCart]) en VendingModalCart, que dispara un re-render
  // POSTERIOR), si showModalPayment no vuelve a cambiar entre pagos, registerOrder terminaba
  // mandando estos valores en 0/vacio aunque la pantalla ya mostrara el total correcto. Se leen
  // via ref (mismo patron que paymentInfoRef/typePaymentSelectRef) para que siempre reflejen el
  // valor mas reciente sin necesidad de recrear el socket.
  const invoiceTotalRef = useRef(invoiceTotal);
  const invoiceTotalItbmsRef = useRef(invoiceTotalItbms);
  const invoiceSubtotalRef = useRef(invoiceSubtotal);
  const invoiceTotalDiscountRef = useRef(invoiceTotalDiscount);
  const taxesArrayAllRef = useRef(taxesArrayAll);
  const shoppingCartRef = useRef(shoppingCart);
  // cupons/discounts se aplican DESPUES de abrir el modal de pago (ModalCupon vive dentro de esta
  // misma pantalla), asi que estan expuestos al mismo closure obsoleto - sin ref, un cupon
  // aplicado durante el pago no llegaria a registerOrder.
  const cuponsRef = useRef(cupons);
  const discountsRef = useRef(discounts);

  useEffect(() => { invoiceTotalRef.current = invoiceTotal; }, [invoiceTotal]);
  useEffect(() => { invoiceTotalItbmsRef.current = invoiceTotalItbms; }, [invoiceTotalItbms]);
  useEffect(() => { invoiceSubtotalRef.current = invoiceSubtotal; }, [invoiceSubtotal]);
  useEffect(() => { invoiceTotalDiscountRef.current = invoiceTotalDiscount; }, [invoiceTotalDiscount]);
  useEffect(() => { taxesArrayAllRef.current = taxesArrayAll; }, [taxesArrayAll]);
  useEffect(() => { shoppingCartRef.current = shoppingCart; }, [shoppingCart]);
  useEffect(() => { cuponsRef.current = cupons; }, [cupons]);
  useEffect(() => { discountsRef.current = discounts; }, [discounts]);

  useEffect(() => {
    return () => {
      if (remotePaymentFallbackTimeoutRef.current) clearTimeout(remotePaymentFallbackTimeoutRef.current);
    };
  }, []);

  setTimeout(() => {
    if (inputRefLog.current != null) {
      inputRefLog.current.focus()
    }
  }, 1000);

  useEffect(() => {
    let isCancelled = false;
    let retryTimeout = null;

    const validateTemperatureBeforeNewOrder = async () => {
      if (isCancelled) return;

      setNewOrderTemperatureChecking(true);

      try {
        const temperatureReady = typeof getTemp === "function"
          ? await getTemp(true)
          : statusComunicationVending === true;

        if (isCancelled) return;

        setNewOrderTemperatureReady(temperatureReady === true);

        if (temperatureReady !== true) {
          retryTimeout = setTimeout(validateTemperatureBeforeNewOrder, 2000);
        }
      } catch (err) {
        if (isCancelled) return;

        setNewOrderTemperatureReady(false);
        retryTimeout = setTimeout(validateTemperatureBeforeNewOrder, 2000);
      } finally {
        if (!isCancelled) {
          setNewOrderTemperatureChecking(false);
        }
      }
    }

    if (showModalConfirmation == true) {
      setNewOrderTemperatureReady(false);
      validateTemperatureBeforeNewOrder();
    } else {
      setNewOrderTemperatureReady(false);
      setNewOrderTemperatureChecking(false);
    }

    return () => {
      isCancelled = true;
      if (retryTimeout != null) clearTimeout(retryTimeout);
    }
  }, [showModalConfirmation]);


  const handleChangeYappy = (txt) => {
    if (txt == '0') {
      setModalYappyQr(false)
      oledScreenPayments();
      inputRefLogYappy.current.value = ""

      inputRefLog.current.focus()
    } else {
      inputRefLogYappy.current.value = ""
    }
  }

  const handleChange = (e) => {

    if (e.key == "Enter") {
      let inputValue = e.target.value
      getCouponByCode(inputValue);
      document.getElementById("inputCodeQrDiscount").value = ""
    }
  }

  const clearInputPayment = (txt) => {
    if (txt == undefined) { inputRefLog.current.value = "" } else { inputRefLog.current.value = txt }
    inputRefLog.current.focus()
    console.log('Limpiar');
  }


  const getCouponByCode = async (code) => {
    console.log("CODIGO CUPON: ", code);
    try {
      const response = await CouponPosFetchAPI.getCupon(code, token)
      actionCupon(response.data)
      console.log(response);
    } catch (err) {
      console.log(err);
      ErrorAlert("", "Codigo de cupon ingresado no es valido", "warning")
    }
  }

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const actionCupon = (data) => {
    console.log("Accion cupon: ", data);
    let discount_type = data.cupon.discount_type
    if (discount_type == "PERCENTAGE") {
      let dataCupon = {
        "cupon_id": data.cupon.id,
        "user_id": null,
        "groups": [],
        "combos": []
      }
      let discountRate = data.cupon.discount_value
      let totalDiscountApplied = 0

      for (let i = 0; i < shoppingCart.length; i++) {
        let discount = ((shoppingCart[i].price * discountRate) / 100)
        console.log(discount)
        shoppingCart[i].unit_discount = discount;
        shoppingCart[i].product_discount = discount;
        shoppingCart[i].descuento = discount;
        shoppingCart[i].discount = discount;
        dataCupon.groups.push({ group_id: shoppingCart[i].group_id, amount: 1 })
        totalDiscountApplied += discount * shoppingCart[i].amount
      }

      // No hay un tipo "discounts" propio de cupon en el backend (discount_id de la tabla `discounts`),
      // por eso se manda discount_id: null y se hace enfasis en el cupon aplicado dentro de "name".
      let cuponReference = data.cupon.name || data.cupon.code_prefix || `#${data.cupon.id}`
      setDiscounts([...discounts, {
        discount_id: null,
        cupon_id: data.cupon.id,
        name: `Cupón: ${cuponReference}`,
        total: totalDiscountApplied,
        percentage: `${discountRate}%`,
        beneficiary: { client_id: 0, client_name: "", user_id: 0, user_name: "" },
        aprrovedby: { user_id: 0, user_name: "Cupón automático" },
        groups: dataCupon.groups,
        combos: []
      }])

      setCupons([...cupons, dataCupon])
      setShoppingCart(shoppingCart);
      calculateInvoiceTotals(shoppingCart)
      ErrorAlert("", "Descuento aplicado con exito", "success")
    }
  }


  const getDiscountByCode = async (code) => {
    try {
      const response = await DiscountFetchAPI.getDiscountByCode(code, token);
      let discountRate = response.data.data.discount.discountRate
      console.log(discountRate)
      console.log(shoppingCart)

      for (let i = 0; i < shoppingCart.length; i++) {
        let discount = ((shoppingCart[i].price * discountRate) / 100)
        console.log(discount)
        shoppingCart[i].unit_discount = discount;
        shoppingCart[i].product_discount = discount;
        shoppingCart[i].descuento = discount;
        shoppingCart[i].discount = discount;
      }
      setShoppingCart(shoppingCart);
      calculateInvoiceTotals(shoppingCart)
      ErrorAlert("", "Descuento aplicado con exito", "success")

    } catch (err) {
      ErrorAlert("", "Descuento no encontrado", "error")
      console.log(err)
    }
  }

  const getPaymentsMethod = async () => {
    try {
      const response = await PaymentMethodFetchAPI.getPaymentMethod(machine.id, token);
      setPayments(response.data.data)
    } catch (err) {
      console.log(err);
    }
  }

  const authDgi = async () => {
    let message = "";
    let titleAlert = "";
    let icon = "";
    try {
      const response = await AuthDgiFetchAPI.authenticationRuc(token, data)

      let dataDgi = response.data
      if (dataDgi.dgi_response.gResProc) {
        if (dataDgi.dgi_response.gResProc.dCodRes == "0680") {
          data.dv = response.data.dgi_response.dDV;
          data.ruc = response.data.dgi_response.dRuc;
          data.name = response.data.dgi_response.dNomb;
          setData(data)
          setShowModalDatos(false)

          message = "Datos del clientes obtenidos por la DGI"
          titleAlert = "Datos obtenido correctamente"
          icon = "success"
          ErrorAlert(message, title, icon)

        } else {
          message = "Ingrese los datos manualmente."
          titleAlert = "Datos no encontrados"
          icon = "warning"
          ErrorAlert(message, title, icon)
        }
      }
    } catch (err) {
      ErrorAlert("", "Datos no encontrados en la DGI", "error")
      console.log(err);
    }
  }

  const saveDataClient = async () => {
    if (data.ruc == "0-000-00") {
      console.log("hola");
      data.ruc = displayKeyboard;
      setDisplayKeyboard("")
      setTitle("Ingrese el nombre:")
      LoadingAlert()
      authDgi()
    } else if (data.name == "Cliente") {
      data.name = displayKeyboard;
      setDisplayKeyboard("")
      setTitle("Ingrese el dv:")
    } else if (data.dv == "00") {
      data.dv = displayKeyboard;
      setData(data)
      setShowModalDatos(false)
      setDisplayKeyboard("")
      setTitle("Ingrese el ruc:")
    }
  }

  const handleDataClient = () => {
    if (data.ruc == "0-000-00") {
      setShowModalDatos(true)
    } else {
      Swal.fire({
        title: 'Quieres cambiar los datos?',
        text: "Al aceptar se borraran lo datos que ya tenias.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si'
      }).then((result) => {
        if (result.isConfirmed) {
          setData({ name: "Cliente", ruc: "0-000-00", dv: "00" })
          setShowModalDatos(true)
        }
      })
    }
  }

  const infoMachineLocal = async () => {
    const JsonTr = [{
      Tipo: 'INFORMACION',
      Producto: machine.id,
      Monto: 0,
      TipoVenta: 'INFORMACION',
      printer_name: "",
      x_access_token: token,
      branchoffice_id: branchoffice.id
    }];
    try {
      const response = await RequestLocalFetchAPI.postPaymentMethod(JsonTr)
    } catch (err) {
      console.log(err);
    }
  }

  const paymentValidYappy = async (e, payment, phone) => {

    let EMVStreamResponseReponse = "0"
    setShowModalPaymentProcess(true)
    e.preventDefault();
    setDataInfoPaymentSelect(payment.payment)
    let type_Payment = payment.payment

    try {
      const lastOrder = await OrdersFetchAPI.getNumberOrder(branchoffice.id, token);
      let JsonTr = [{
        Tipo: 'SALE',
        Producto: 'COBRAR',
        Itbms: invoiceTotalItbms.toFixed(2),
        Descuento: invoiceTotalDiscount,
        Monto: invoiceTotal.toFixed(2),
        TipoVenta: type_Payment.toUpperCase(),
        paymentMethod: payment,
        orderid: (parseInt(lastOrder.data.last_transaction_code) + 1),
        taxes: invoiceTotalItbms.toFixed(2),
        subtotal: (invoiceTotal.toFixed(2) - invoiceTotalItbms.toFixed(2)),
        total: invoiceTotal,
        tel: "507" + phone,
      }];


      const response = await RequestLocalFetchAPI.postPaymentMethodVending(JsonTr);
      let responseCode = response.data.EMVStreamResponse.responseCode;
      let description = response.data.EMVStreamResponse.responseCodeDescription
      setVoucher_Order("0")

      if (responseCode == "20") {
        setStatusScreen(true);
        setPaymentApproval({ status: 1, description: description });
      } else {
        setPaymentApproval({ status: 2, description: description });
      }
      setTimeout(() => {
        if (responseCode == "20") {
          setShowModalDispense(true);
          setShowModalPayment(false)
          registerOrder(payment.payment_id, EMVStreamResponseReponse, payment);
        }
        setShowModalPaymentProcess(false)
        setPaymentApproval({ status: 0, description: "Procesando pago..." })
      }, 1500);
    } catch (err) {
      console.log(err);
    }
  }

  const paymentValidInitSocket = async (payment) => {
    setPaymentSelect(payment.payment)
    let EMVStreamResponseReponse = "0"
    setShowModalPaymentProcess(true)
    setDataInfoPaymentSelect(payment.payment)

    let data = {
      "amount": invoiceTotal.toFixed(2),
      "invoice": orderNumber,
      "machine_code": machine.code,
      "business_code": business.code,
      "branchoffice_code": branchoffice.code,
      "channel": "api",
      "user_code": "",
      "paymenthod_id": payment.payment_id,
      "paymenthod": payment.payment,
      "paymenthod_integration_id": payment.integration_id,
      "taxes": taxesArrayAll,
      "tax": invoiceTotalItbms.toFixed(2),
      "tips": 0,
      "amountWithTips": invoiceTotal.toFixed(2),
    }

    if (payment.payment == "Credito") {
      setPaymentApproval({ status: 1, description: "APROBADO" });
      oledDrop()
      setVoucher_Order("0")
      setStatusScreen(true);

      setTimeout(() => {
        setShowModalDispense(true);
        registerOrder(payment.payment_id, EMVStreamResponseReponse, payment);
        setShowModalPaymentProcess(false)
        setPaymentApproval({ status: 0, description: "Procesando pago..." })
      }, 1500);
    } else {
      // Reset de correlacion: cualquier evento tardio del intento anterior queda invalidado.
      remotePaymentIdRef.current = null;
      processedRemotePaymentIdRef.current = null;
      remotePaymentFallbackAttemptsRef.current = 0;
      if (remotePaymentFallbackTimeoutRef.current) {
        clearTimeout(remotePaymentFallbackTimeoutRef.current);
        remotePaymentFallbackTimeoutRef.current = null;
      }

      console.log(`[VENDING REMOTE PAYMENT] payment_requested`, { invoice: orderNumber });

      try {
        // Llamada real: crea el PinpadRemotePayments de verdad en el backend (local) y devuelve un
        // remote_payment_id real.
        const response = await PaymentComunicationFetchAPI.initPayment(data, token);
        const remotePaymentId = response?.data?.pinpadRemotePayment?._id;
        remotePaymentIdRef.current = remotePaymentId || null;

        console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] frontend_payment_started`);

        if (remotePaymentId) {
          remotePaymentFallbackTimeoutRef.current = setTimeout(() => {
            checkRemotePaymentFallback(remotePaymentId);
          }, REMOTE_PAYMENT_FALLBACK_INITIAL_DELAY_MS);
        }
      } catch (err) {
        console.log(err);
        setShowModalPaymentProcess(false)
      }
    }
  }

  const paymentValid = async (payment) => {
    setPaymentSelect(payment.payment)
    let EMVStreamResponseReponse = "0"
    setShowModalPaymentProcess(true)

    setDataInfoPaymentSelect(payment.payment)
    if (payment.payment == "Credito") {
      setPaymentApproval({ status: 1, description: "APROBADO" });
      oledDrop()
      setVoucher_Order("0")
      setStatusScreen(true);

      setTimeout(() => {
        setShowModalDispense(true);
        registerOrder(payment.payment_id, EMVStreamResponseReponse, payment);
        setShowModalPaymentProcess(false)
        setPaymentApproval({ status: 0, description: "Procesando pago..." })
      }, 1500);
    } else {

      console.log("ENTRE A SELECCIONAR");

      let type_Payment = ""
      if (payment.payment == "MasterCard") {
        type_Payment = "MC"
      } else {
        type_Payment = payment.payment
      }
      try {
        const lastOrder = await OrdersFetchAPI.getNumberOrder(branchoffice.id, token);
        let JsonTr = [{
          Tipo: 'SALE',
          Producto: 'COBRAR',
          Itbms: invoiceTotalItbms,
          Descuento: invoiceTotalDiscount,
          Monto: invoiceTotal.toFixed(2),
          TipoVenta: type_Payment.toUpperCase(),
          paymentMethod: payment,
          orderid: (parseInt(lastOrder.data.last_transaction_code) + 1),
        }];

        const response = await RequestLocalFetchAPI.postPaymentMethod(JsonTr);

        console.log(response);
        let responseCode = response.data.EMVStreamResponse.responseCode;
        let description = response.data.EMVStreamResponse.responseCodeDescription
        console.log(response.data.EMVStreamResponse.voucher);
        setVoucher_Order(response.data.EMVStreamResponse.voucher);

        if (type_Payment != "Yappy" && type_Payment != "Efectivo" && type_Payment != "Credito") {
          setDataParamsPaymentVoucher({ authorizationNumber: response.data.EMVStreamResponse.authorizationNumber, referenceNumber: response.data.EMVStreamResponse.referenceNumber, systemTraceNumber: response.data.EMVStreamResponse.systemTraceNumber })
          EMVStreamResponseReponse = response.data.EMVStreamResponse
        } else {
          setVoucher_Order("0")
        }

        if (responseCode == "00") {
          setStatusScreen(true);
          setPaymentApproval({ status: 1, description: description });
          oledDrop()
        } else {
          setPaymentApproval({ status: 2, description: description });
          olederror(description);
        }
        setTimeout(() => {
          if (responseCode == "00") {
            setShowModalDispense(true);
            registerOrder(payment.payment_id, EMVStreamResponseReponse, payment);
          }
          setShowModalPaymentProcess(false)
          setPaymentApproval({ status: 0, description: "Procesando pago..." })
        }, 1500);
      } catch (err) {
        setShowModalPaymentProcess(false)
        olederror()
        console.log(err);
      }
    }
  }

  const formatVoucherString = (voucher) => {
    const maskedVoucher = voucher.replace(/(\d{6})\d+(\d{4})/g, "$1XXXXXX$2");
    const formattedVoucher = `${maskedVoucher}`;
    console.log(formattedVoucher);
    setVoucher_Order(formattedVoucher)
  };

  const voidTypeMachineValid = () => {
    if (machine.machine_subtype_code === "VPD" || machine.machine_subtype_code === "VAP") {
      console.log("Socket");
      voidCreditDebitToSocket()
    } else {
      console.log("Local request");
      voidCreditDebit()
    }
  }

  const voidCreditDebitToSocket = async () => {
    console.log("Haciendo void");
    if (dataInfoPaymentSelect == "Yappy QR") {
      console.log("Aqui en yappy1");
      reversalYappyQr()
    }
    else if (dataInfoPaymentSelect == "Credito") {
      registerOrderTempReturn({ EMVStreamResponse: "0" })
    } else {
      let IdTerminal = paymentInfo.payment_data.params.find(param => param.name === "ID_TERMINAL").value
      let data = {
        "amount": invoiceTotal.toFixed(2),
        "invoice": orderNumber,
        "machine_code": machine.code,
        "business_code": business.code,
        "branchoffice_code": branchoffice.code,
        "channel": "api",
        "user_code": "",
        "paymenthod_id": paymentInfo.payment_data.payment_id,
        "paymenthod": paymentInfo.payment_data.payment,
        "paymenthod_integration_id": paymentInfo.payment_data.integration_id,
        "taxes": taxesArrayAll,
        "tax": invoiceTotalItbms.toFixed(2),
        "tips": 0,
        "amountWithTips": invoiceTotal.toFixed(2),
        "_pinpadrequestdata": {
          "params": [
            { "name": "tipo", "value": "VOID" },
            { "name": "terminalId", "value": IdTerminal },
            { "name": "invoice", "value": orderNumber },
            { "name": "authorizationNumber", "value": dataParamsPaymentVoucher.authorizationNumber },
            { "name": "referenceNumber", "value": dataParamsPaymentVoucher.referenceNumber },
            { "name": "systemTraceNumber", "value": dataParamsPaymentVoucher.systemTraceNumber },
            { "name": "tipoVenta", "value": paymentInfo.payment_data.payment }
          ]
        }
      }
      try {
        setTypePaymentSelect("void")
        LoadingAlert("Procesando devolucion...")
        const json = [{ Tipo: "VOID", TipoVenta: "VOID", authorizationNumber: dataParamsPaymentVoucher.authorizationNumber, referenceNumber: dataParamsPaymentVoucher.referenceNumber, systemTraceNumber: dataParamsPaymentVoucher.systemTraceNumber, paymentMethod: { id: paymentInfo.payment_data.payment_id, payment: paymentInfo.payment_data.payment, payment_id: paymentInfo.payment_data.payment_id, machine_id: paymentInfo.payment_data.machine_id, params: paymentInfo.payment_data.params } }];
        console.log(json);
        const response = await PaymentComunicationFetchAPI.voidPayment(data, token);
        console.log(response.data);

      } catch (err) {
        console.log(err);
      }
    }
  }

  const reversalYappyQr = async () => {
    try {
      LoadingAlert("Procesando devolucion...")
      let yappy_transaction_id = dataYappy.yappy_transaction.body.transactionId
      const response = await YappyFetchAPI.reverseYappyTransaction({ yappy_transaction_id: yappy_transaction_id, params: [] }, token);
      let newVoucher = { EMVStreamResponse: "Transaccion reversada #" + yappy_transaction_id }
      console.log(response);
      registerOrderTempReturn(newVoucher)

    } catch (err) {
      if (err.response) {
        console.log(err.response)
        if (err.response.data && err.response.data.error.code === "YP-0002") {
          registerOrderTempReturn({ EMVStreamResponse: 0 })
        } else {
          registerOrderTempReturn({ EMVStreamResponse: 0 })
        }
      }
    }
  }

  const voidCreditDebit = async () => {
    if (dataInfoPaymentSelect == "Credito") {
      registerOrderTempReturn({ EMVStreamResponse: "0" })
    } else if(dataInfoPaymentSelect === "Yappy QR"){
      console.log("Aqui en yappy2");
      reversalYappyQr()
    } else {
      try {
        LoadingAlert("Procesando devolucion...")
        console.log(paymentInfo);
        const json = [{ Tipo: "VOID", TipoVenta: "VOID", authorizationNumber: dataParamsPaymentVoucher.authorizationNumber, referenceNumber: dataParamsPaymentVoucher.referenceNumber, systemTraceNumber: dataParamsPaymentVoucher.systemTraceNumber, paymentMethod: { id: paymentInfo.payment_data.payment_id, payment: paymentInfo.payment_data.payment, payment_id: paymentInfo.payment_data.payment_id, machine_id: paymentInfo.payment_data.machine_id, params: paymentInfo.payment_data.params } }];
        console.log(json);
        const response = await RequestLocalFetchAPI.postPaymentMethod(json);
        console.log(response.data);
        let newVoucher = { EMVStreamResponse: response.data.EMVStreamResponse }
        setVoucher_Order(response.data.EMVStreamResponse.voucher);

        if (response.data.EMVStreamResponse.responseCodeDescription) {
          if (response.data.EMVStreamResponse.responseCodeDescription == "APROBADA") {
            registerOrderTempReturn(newVoucher)
            oledsuccessVoid()
          } else {
            ErrorAlert("No se aplico la devolucion.", "Error en la devolucion", "error")
            olederror("Error en la devolucion", false)
          }
        } else {
          ErrorAlert("No se aplico la devolucion.", "Error en la devolucion", "error")
          olederror("Error en la devolucion", false)
        }

      } catch (err) {
        console.log(err);
      }
    }
  }

  const registerOrderTempReturn = async (data_bank_voucher_response) => {

    let token = localStorage.getItem('x-access-token');
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice_vending'))
    let business = JSON.parse(localStorage.getItem('business_vending'));

    try {
      const response = await OrderReturnFetchAPI.registerOrderReturn(transaction_code_register, business.code, branchoffice.code, token, data_bank_voucher_response);
      console.log(response);
      ErrorAlert("Devolucion exitosa.", "La devolucion se realizo correctamente ", "success")
      console.log(response.data.data.dgi_qr);

      if (response.data.data.dgi_qr == "") {
        setDataRutaQr("0")
      } else {
        setDataRutaQr(response.data.data.dgi_qr)
      }
      console.log(response.data.data.order_code);
      setOrder_code_register(response.data.data.order_code)
      setDataNoteCredit(true);

    } catch (err) {
      console.log(err);
    }
  }


  const selectPayment = (e, payment) => {
    setAtivityTimer(2)
    e.preventDefault();
    getRunningstate(payment)
  }

  const getRunningstate = async (payment) => {
    if (machine.machine_subtype_code === "VAG" || machine.machine_subtype_code === "VAP") {
      try {
        const response = await VendingAndroidFetchAPI.getRunningState(machine.divices.android_ip)
        if (response.data.runningState == 2) {
          selectprocessPayment(payment)
        } else {
          ErrorAlert("La máquina no está lista para procesar el pago.", "Máquina en error", "error")
        }
      } catch (err) {
        ErrorAlert("La máquina no está lista para procesar el pago.", "Máquina en error", "error")
      }
    } else { selectprocessPayment(payment) }
  }


  const selectprocessPayment = (payment) => {
    // Para probar sin hardware local (vending física) cambia esta constante a `true`
    const bypassVendingStatusCheck = false;
    if (bypassVendingStatusCheck || statusComunicationVending == true) {//Esta condicion siempre debe esta en true para pruebas de desarrollo false
      setPaymentInfo({ payment: payment.payment, payment_id: payment.payment_id, payment_data: payment })
      if (payment.payment == "Yappy") {
        handlerYappy(payment)
      } else if (payment.payment == "Yappy QR") {
        GenerateYappyTransaction(payment)
      } else {
        setTypePaymentSelect("pay")

        if (machine.machine_subtype_code === "VPD" || machine.machine_subtype_code === "VAP") {
          console.log("socket");
          paymentValidInitSocket(payment)
        } else {
          console.log("local request");
          paymentValid(payment)
        }
      }
    } else {
      setShowModaloutService(true)
    }
  }

  const registerOrder = async (payment_id, EMVStreamResponseReponse, payment) => {

    console.log(EMVStreamResponseReponse);
    console.log(payment);
    let token = localStorage.getItem('x-access-token')

    let json = {
      "EMVStreamResponse": EMVStreamResponseReponse,
      "client_name": data.name,
      "id_Client": 0,
      // "0-000-00"/"00" son solo el centinela interno del flujo de captura de RUC (ver
      // saveDataClient/handleDataClient); si el cliente nunca ingreso un RUC real, se manda 0
      // en vez de ese string - el formato "0-000-00" rompia la creacion de notas de credito
      // sobre estas ordenes.
      "ruc": data.ruc === "0-000-00" ? 0 : data.ruc,
      "dv": data.dv === "00" ? 0 : data.dv,
      "localizador": 0,
      "client_phone": "0",
      "dgi_qr": "0",
      "Orden": shoppingCartRef.current,
      "Descuento": invoiceTotalDiscountRef.current,
      "Total": invoiceTotalRef.current,
      "itbms": invoiceTotalItbmsRef.current,
      "taxes": taxesArrayAllRef.current,
      "subtotal": invoiceSubtotalRef.current,
      "machine_id": machine.id,
      "branchoffice_id": branchoffice.id,
      "tipoOrden": "comer aqui",
      "paymethod": payment_id,
      "paymenthod_integration_id": payment.integration.id,
      "cupons": cuponsRef.current,
      "discounts": discountsRef.current,
      "transaction_code": orderNumber,
    }

    if (payment.payment == "Yappy QR") {
      json.yappy_transaction_id = dataYappy.yappy_transaction.body.transactionId
    }
    try {
      localStorage.setItem('countNotification', 0);
      const response = await OrderNumberFetchAPI.registerOrder(json, token)
      setOrder_code_register(response.data.data.order_code)
      setTransaction_code_register(response.data.data.transaction_code)
      shoppingCartDispense(payment.payment, response.data.data.order_code);
      getOrder(response.data.data.transaction_code);

      if (response.data.data.micros_params != null) {
        let micros_params = response.data.data.micros_params;
        let ip = micros_params.localMicrosServerIp
        createCheckMicrosOrderLocal(ip, micros_params.RvcRef, micros_params.employeeNum, micros_params.host_url, micros_params, token, response.data.data.order_id);
      } else {
        console.log("no hay parametros de micros");
      }
    } catch (err) {
      console.log(err);
      setShowModalDispense(false);
      ErrorAlert('', 'Error de registro', 'error');
    }
  }

  const createCheckMicrosOrderLocal = async (ip, RvcRef, employeeNum, host_url, orderData, token, order_id) => {
    let data = {
      Ruta: `http://${ip}:9472/api/micros/checks?RvcRef=${RvcRef}&employeeNum=${employeeNum}&host_url=${host_url}`,
      Type: "POST",
      Header: { "x-access-token": token },
      Body: orderData
    };
    let micros_response;
    console.log("entre a peticion local micros");

    try {
      micros_response = await RequestLocalFetchAPI.postMicros(data);
      console.log(micros_response);
      try {
        if (micros_response.data.micros_response.PostTransactionExResponse.pTotalsResponse.OperationalResult.ErrorCode._text !== undefined && micros_response.data.micros_response.PostTransactionExResponse.pTotalsResponse.OperationalResult.ErrorCode._text === "Success") {
          console.log("vamos a actualizar")
          let data_to_update = {
            micros_reference: {
              checkNum: micros_response.data.micros_response.PostTransactionExResponse.pGuestCheck.CheckNum._text,
              checkSeq: micros_response.data.micros_response.PostTransactionExResponse.pGuestCheck.CheckSeq._text,
            }
          }
          const response = await OrdersFetchAPI.updateOrder(order_id, data_to_update, token);
          console.log(response)
        }
      } catch (err) {
        console.log(err)
      }
    } catch (err) {
      console.log(err);
    }
  }


  const decimalReduction = (value) => {
    let string = value.toString()
    let arrayString = string.split(".");
    let newDecimalString = []
    let sample = ''
    if (arrayString[1] != undefined) {
      newDecimalString = arrayString[1].slice(0, 2);
      sample = arrayString[0] + "." + newDecimalString
      console.log("Hice la reduccion");
    } else {
      console.log("Array: " + arrayString);
      console.log("Decimal: " + newDecimalString);
      console.log("Nuevo valor: " + sample);
      sample = string;
    }

    let endValue = parseFloat(sample)
    return endValue
  }

  const GenerateYappyTransaction = async (payment) => {
    setDataInfoPaymentSelect(payment.payment)
    LoadingAlert()

    let token = localStorage.getItem('x-access-token');
    let machine = JSON.parse(localStorage.getItem('machine_vending'));
    let dataOrder = JSON.parse(localStorage.getItem('Detail_order'))
    let data = {
      "machine_id": machine.id,
      "total": decimalReduction(invoiceTotal).toString(),
      "subtotal": decimalReduction(invoiceTotal).toString(),
      "tax": "0",
      "discount": "0",
      "transaction_code": orderNumber,
      "description": "Smartpay - orden:" + orderNumber,
      "params": payment.params
    }
    try {
      const response = await YappyFetchAPI.newYappyQr(data, token)
      console.log(response);

      ErrorAlert("", "Todo listo para que realices el pago", "info")
      setDataYappy(response.data);

      oledQrYappy(response.data.yappy_transaction.body.hash)
      setDataHash(response.data.yappy_transaction.body.hash)
      console.log(response.data.yappy_transaction.body.hash);
      setModalYappyQr(true)
      setStatusRequestYappy(true)

    } catch (err) {
      ErrorAlert("", "Lo sentimos yappy no esta disponible", "warning")
      olederror('  Yappy no disponible')
      console.log(err);
    }
  }

  const hadleCancelYappy = (text) => {

    if (text != undefined) {
      setPaymentApproval({ status: 2, description: text });
    } else {
      setPaymentApproval({ status: 2, description: "CANCELADO" });
    }

    setModalYappyQr(false);
    setStatusRequestYappy(false)
    console.log("cancele yappy");

    setTimeout(() => {
      setPaymentInfo({ payment: "", payment_id: 0 })
      setPaymentApproval({ status: 0, description: "Procesando pago..." })
    }, 3000);
  }

  const getYappyTransaction = async () => {
    console.log(dataYappy);
    let token = localStorage.getItem('x-access-token');

    try {
      let yappy_transaction_id = dataYappy.yappy_transaction.body.transactionId
      console.log(yappy_transaction_id);

      const response = await YappyFetchAPI.getYappyTransaction(yappy_transaction_id, token);
      console.log(response);

      let status = response.data.yappy_transaction.body.status;

      switch (status) {
        case 'PENDING':
          console.log("Transaccion pendiente");
          break;

        case 'COMPLETED':
          console.log("Transaccion aprobada");
          oledDrop()
          setVoucher_Order("0")
          setModalYappyQr(false)
          setStatusRequestYappy(false)
          setShowModalDispense(true);
          setShowModalPayment(false)
          setPaymentApproval({ status: 1, description: "APROBADO" })
          registerOrder(paymentInfo.payment_id, yappy_transaction_id, paymentInfo.payment_data);
          break;

        case 'DECLINED':
          olederror('        DECLINED')
          setPaymentInfo({ payment: "", payment_id: 0 })
          console.log("Transaccion declinda");
          setDataHash("")
          hadleCancelYappy('DECLINED')
          break;

        case 'EXPIRED':
          olederror('        EXPIRED')
          setPaymentInfo({ payment: "", payment_id: 0 })
          console.log("Transaccion expirada");
          setDataHash("");
          hadleCancelYappy('EXPIRED')
          break;

        case 'FAILED':
          olederror('        FAILED')
          setPaymentInfo({ payment: "", payment_id: 0 })
          console.log("Transaccion fallida");
          setDataHash("")
          hadleCancelYappy('FAILED')
          break;

        case 'VOIDED':
          olederror('        VOIDED')
          setPaymentInfo({ payment: "", payment_id: 0 })
          console.log("Transaccion Eliminada");
          setDataHash("")
          hadleCancelYappy('VOIDED')
          break;
      }

    } catch (err) {
      console.log(err);
      setPaymentInfo({ payment: "", payment_id: 0 })
      setDataHash("")
      hadleCancelYappy("ERROR DE CONSULTA")
      olederror()
    }
  }

  const getOrder = async (transaction_code) => {
    console.log("Estoy en consultar orden");
    try {
      const response = await FilterOrderFetchAPI.getOrder(transaction_code, branchoffice.code, business.code, token)
      console.log(response.data.EMVStreamResponse.voucher);
      setVoucher_Order(response.data.EMVStreamResponse.voucher)
      formatVoucherString(response.data.EMVStreamResponse.voucher)
    } catch (err) {
      console.log(err);
    }
  }

  const handlerYappy = (payment) => {
    setPaymentSelect(payment.payment)
    setShowModalYappy(true)
    setSelectPaymentYappy(payment)
  }


  // ============================================================
  // PAYMENT METHODS
  // ============================================================
  useEffect(() => {
    const updateConfig = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      const portrait = h > w;

      let cols, rows;
      if (portrait) {
        // VERTICAL: SIEMPRE 2 columnas
        if (w >= 900) { cols = 2; rows = 3; }       // 6 por página
        else if (w >= 600) { cols = 2; rows = 3; }  // 6
        else if (w >= 420) { cols = 2; rows = 3; }  // 6
        else { cols = 2; rows = 3; }                // 6
      } else {
        // HORIZONTAL: se mantiene
        if (w >= 1400) { cols = 5; rows = 2; }
        else if (w >= 1100) { cols = 4; rows = 2; }
        else if (w >= 900) { cols = 4; rows = 2; }
        else if (w >= 600) { cols = 3; rows = 2; }
        else { cols = 3; rows = 1; }
      }
      setPaymentGridConfig({ cols, rows });
    };
    updateConfig();
    window.addEventListener('resize', updateConfig);
    window.addEventListener('orientationchange', updateConfig);
    return () => {
      window.removeEventListener('resize', updateConfig);
      window.removeEventListener('orientationchange', updateConfig);
    };
  }, []);

  const paymentPageSize = paymentGridConfig.cols * paymentGridConfig.rows;
  const paymentTotalPages = Math.max(1, Math.ceil((payments?.length || 0) / paymentPageSize));
  const paymentPages = useMemo(() => {
    if (!payments || !Array.isArray(payments)) return [[]];
    const out = [];
    for (let i = 0; i < paymentTotalPages; i++) {
      out.push(payments.slice(i * paymentPageSize, (i + 1) * paymentPageSize));
    }
    return out.length ? out : [[]];
  }, [payments, paymentPageSize, paymentTotalPages]);

  useEffect(() => {
    if (paymentPage >= paymentTotalPages) setPaymentPage(0);
  }, [paymentTotalPages, paymentPage]);

  useEffect(() => {
    if (showModalPayment) setPaymentPage(0);
  }, [showModalPayment]);

  const goPaymentPrev = () => setPaymentPage(p => Math.max(0, p - 1));
  const goPaymentNext = () => setPaymentPage(p => Math.min(paymentTotalPages - 1, p + 1));

  const handlePaymentTouchStart = (e) => { paymentTouchStartX.current = e.touches[0].clientX; };
  const handlePaymentTouchEnd = (e) => {
    if (paymentTouchStartX.current == null) return;
    const dx = e.changedTouches[0].clientX - paymentTouchStartX.current;
    if (Math.abs(dx) > 50) { dx < 0 ? goPaymentNext() : goPaymentPrev(); }
    paymentTouchStartX.current = null;
  };


  // ============================================================
  // viewPayment con paginación horizontal
  // Lógica preservada: payments, selectPayment, payment.payment, payment.img
  // ============================================================
  const viewPayment = () => {
    return (
      <div className="vmpm-root">

        <div className="vmpm-stage">
          <div
            className="vmpm-viewport"
            onTouchStart={handlePaymentTouchStart}
            onTouchEnd={handlePaymentTouchEnd}
          >
            <div
              className="vmpm-pages"
              style={{ transform: `translateX(-${paymentPage * 100}%)` }}
            >
              {paymentPages.map((pageItems, pIdx) => (
                <div
                  key={pIdx}
                  className={`vmpm-page ${pIdx === paymentPage ? 'is-active' : ''}`}
                  aria-hidden={pIdx !== paymentPage}
                >
                  <div
                    className="vmpm-grid"
                    style={{
                      '--grid-cols': paymentGridConfig.cols,
                      '--grid-rows': paymentGridConfig.rows,
                    }}
                  >
                    {pageItems.map((payment) => (
                      <div
                        key={payment.payment}
                        className="vmpm-card"
                        onClick={async (e) => selectPayment(e, payment)}
                      >
                        <input
                          type="radio"
                          className="btn-check vmpm-card-input"
                          name="option_payments"
                          id={payment.payment + "payment"}
                        />
                        <label
                          className="vmpm-card-label"
                          htmlFor={payment.payment + "payment"}
                        >
                          <div className="vmpm-card-media">
                            <img
                              src={buildCloudinaryImageUrl({url: payment.img, width: 300, type: "image", quality: "auto"})}
                              loading='lazy'
                              className="vmpm-card-img"
                              alt={payment.payment}
                            />
                          </div>

                          <div className="vmpm-card-info">
                            <span className="vmpm-card-tag">Método</span>
                            <h6 className="vmpm-card-title">{payment.payment}</h6>
                          </div>

                          <span className="vmpm-card-check">
                            <i className="uil uil-check"></i>
                          </span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {paymentTotalPages > 1 && (
          <div className="vmpm-navbar">
            <button
              className="vmpm-nav"
              onClick={(e) => { e.stopPropagation(); goPaymentPrev(); }}
              disabled={paymentPage === 0}
              aria-label="Página anterior"
            >
              <i className="uil uil-angle-left-b"></i>
            </button>

            <div className="vmpm-pagebar">
              <span className="vmpm-pagebar-label">
                <b>{paymentPage + 1}</b>
                <span className="vmpm-pagebar-sep">/</span>
                <b>{paymentTotalPages}</b>
              </span>
              <div className="vmpm-pagebar-dots">
                {paymentPages.map((_, i) => (
                  <button
                    key={i}
                    className={`vmpm-pagebar-dot ${i === paymentPage ? 'is-active' : ''}`}
                    onClick={(e) => { e.stopPropagation(); setPaymentPage(i); }}
                    aria-label={`Ir a página ${i + 1}`}
                  />
                ))}
              </div>
            </div>

            <button
              className="vmpm-nav"
              onClick={(e) => { e.stopPropagation(); goPaymentNext(); }}
              disabled={paymentPage >= paymentTotalPages - 1}
              aria-label="Página siguiente"
            >
              <i className="uil uil-angle-right-b"></i>
            </button>
          </div>
        )}
      </div>
    );
  };

  const getdivise = async () => {
    try {
      const response = await DivicesFechtAPI.getDivices(machine.id, token)
      console.log(response);
    } catch (err) {
      console.log(err);
    }
  }

  const sendMessage = async () => {
    console.log("entre aqui");
    try {
      const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, token)
      console.log(response_machine);
      let data = {
        "notification_type": "smartpay_notification",
        "branchoffice_id": branchoffice.id,
        "business_id": business.id,
        "phone_to_send": branchoffice.branchoffice_support_phone,
        "header_text": "Error de despacho",
        "message_body": [{ "text": response_machine.data.data.machine_name + "de la empresa " + business.name + " no se despacho correctamente el producto en la posicion: " + "X:" + shoppingCart[0].X + ", Y:" + shoppingCart[0].Y + " de la orden: " + order_code_register + ", metodo de pago: " + paymentSelect }]
      }

      console.log("entre y envie mensaje");
      const response = await WhatsappFetchAPI.sendNotificationWhatsapp(data, token)
      console.log(response);
    } catch (err) {
      console.log("entre error en mensaje");
      console.log(err);
    }
  }

  const sendMessage2 = async (payment, order_code) => {
    machine = JSON.parse(localStorage.getItem('machine_vending'))
    branchoffice = JSON.parse(localStorage.getItem('branchoffice_vending'))
    business = JSON.parse(localStorage.getItem('business_vending'))


    try {
      const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, token);

      let data = {
        "notification_type": "smartpay_notification",
        "branchoffice_id": branchoffice.id,
        "business_id": business.id,
        "phone_to_send": branchoffice.branchoffice_support_phone,
        "header_text": "Error de comunicacion",
        "message_body": [{ "text": response_machine.data.data.machine_name + " de la empresa " + business.name + " no se despacho correctamente el producto en la posicion: " + "X:" + shoppingCart[0].X + ", Y:" + shoppingCart[0].Y }, { "text": "de la orden: " + order_code + ", metodo de pago: " + payment }]
      }
      console.log(data);
      const response = await WhatsappFetchAPI.sendNotificationWhatsapp(data, token)
      console.log(response);
    } catch (err) {
      console.log(err);
    }
  }

  let intervalNewOrder = 0
  const shoppingCartDispense = async (payment, order_code) => {
    console.log(payment + " " + order_code);

    let tempDispense = new Array;
    let statusValid = 0;
    for (let item = 0; item < shoppingCart.length; item++) {
      let res = 0;
      if (shoppingCart[item].amount > 1) {
        for (let i = 0; i < shoppingCart[item].amount; i++) {
          if (machine.machine_subtype_code == "VCG" || machine.machine_subtype_code == "VPD") {
            res = await dispense(shoppingCart[item].X, shoppingCart[item].Y);
          } else if (machine.machine_subtype_code == "VGG") {

            console.log("entre a snakky despacho");
            res = await dispenseSnakky(shoppingCart[item].X)
            setTimeout(async () => {
              await dispenseSnakky(shoppingCart[item].Y)
            }, 100)

            setTimeout(async () => {
              let statusDispence = await dispenseSnakkyStatus("5000")
              if (statusDispence == 200) {
              }
            }, 10000)
          }
          tempDispense.push(shoppingCart[item]);
          updateStockItem(shoppingCart[item].group_id, shoppingCart[item].position_id, (shoppingCart[item].stock - 1))
          setItemReadyDispense(tempDispense);
          setEventDispense(1);
        }
        finishDispensed()
      } else {

        let status = 0
        let newItemDispense = shoppingCart[item]
        try {

          if (machine.machine_subtype_code == "VCG" || machine.machine_subtype_code == "VPD" || machine.machine_subtype_code == "VAG" || machine.machine_subtype_code == "VAP") {

            if (machine.machine_subtype_code == "VAG" || machine.machine_subtype_code == "VAP") {
              res = await dispenseAndroid(shoppingCart[item].X, shoppingCart[item].Y);
              status = res.data.ResultadoDespachado.totalResult
            } else {
              res = await dispense(shoppingCart[item].X, shoppingCart[item].Y);
              status = res.data.Result[0].shipresult
            }


            if (status == 0) {
              updateStockItem(shoppingCart[item].group_id, shoppingCart[item].position_id, (shoppingCart[item].stock - shoppingCart[item].amount))
              newItemDispense.status = "success"
              setItemReadyDispense([...itemReadyDispense, newItemDispense]);
              tempDispense.push(shoppingCart[item]);
              setItemReadyDispense(tempDispense);
              setEventDispense(1);
              finishDispensed()
            } else {
              throw new Error("Error en el proceso de despacho");
            }
          } else if (machine.machine_subtype_code == "VGG") {
            await dispenseSnakky(shoppingCart[item].X)

            setTimeout(async () => {
              await dispenseSnakky(shoppingCart[item].Y)
              status = 0
            }, 300)

            setTimeout(async () => {
              let datasensore = [{ "comandaVendType": 0, "vendingCode": "4,0,10000" }]
              await VendingSnakkyFetchAPI.keypad(datasensore)
              requestActiveSensorDrop()
            }, 400)

            let turnDrop = 0
            const requestActiveSensorDrop = async () => {
              setTimeout(async () => {
                let statusDispence = await dispenseSnakkyStatus("10000")
                proccessrResponse(statusDispence)
              }, 1000)
            }

            function proccessrResponse(statusDispence) {
              if (statusDispence.data.Informacion == "400") {
                status = 0
                console.log("entre a success 1" + statusDispence.data.Informacion);

                oledsuccess()
                updateStockItem(shoppingCart[item].group_id, shoppingCart[item].position_id, (shoppingCart[item].stock - shoppingCart[item].amount))
                newItemDispense.status = "success"
                setItemReadyDispense([...itemReadyDispense, newItemDispense]);
                tempDispense.push(shoppingCart[item]);
                setItemReadyDispense(tempDispense);
                setEventDispense(1);
                finishDispensed()
              } else {
                if (turnDrop < 15) {
                  console.log("error de despacho # " + turnDrop);
                  turnDrop++
                  requestActiveSensorDrop()
                } else {

                  status = 1
                  console.log("No fue posible realizar el despacho");
                  sendMessage2(payment, order_code);
                  updateStockItem(shoppingCart[item].group_id, shoppingCart[item].position_id, 0)
                  newItemDispense.status = "error"
                  setItemReadyDispense([...itemReadyDispense, newItemDispense]);
                  tempDispense.push(newItemDispense);
                  setItemReadyDispense(tempDispense);
                  setEventDispense(1);
                  setStatusError(true)


                  olederror("Error de despacho", true)
                  statusValid = 1
                  clearStatussentorandlimitDigit(1, "2,1,4,40,20,")

                  setTimeout(() => {
                    inputRefLogDispensed.current.focus()
                  }, 2000);
                }
              }
            }
          }

        } catch (err) {
          status = 1

          console.log("entre a error 2");
          sendMessage2(payment, order_code);
          updateStockItem(shoppingCart[item].group_id, shoppingCart[item].position_id, 0)
          newItemDispense.status = "error"
          setItemReadyDispense([...itemReadyDispense, newItemDispense]);
          tempDispense.push(newItemDispense);
          setItemReadyDispense(tempDispense);
          setEventDispense(1);
          setStatusError(true)

          statusValid = 1

          if (machine.machine_subtype_code == "VGG") {
            setTimeout(() => {
              oledResponse('ERROR', '  Error de despacho');
            }, 500);
          }
        }

      }
    }
    if (statusValid == 1) {
      setStatusError(true)
    }

    function finishDispensed() {
      setReady(true);
      setAtivityTimer(7)
      setNewOrderTemperatureReady(false);
      if (machine.machine_subtype_code === "VGG") {
        setShowModalConfirmation(true);
        setTimeout(() => {
          inputConfirmation.current.focus()
          oledFinishConfirmation()
        }, 1500)
      } else {
        setShowModalConfirmation(true);
        intervalNewOrder = setInterval(() => {
          clearShoppingCart()
        }, 30000);
      }
    }
  }

  const oledResponse = (status, description) => {
    oledComunication(0, '2,0')
    setTimeout(() => {
      oledComunication(0, '2,1,2,35,20,' + status)
    }, 50);

    setTimeout(() => {
      oledComunication(0, '2,1,1,0,40,' + description)
    }, 100);
  }

  const oledsuccess = () => {
    oledComunication(0, '5,0,2,0');
    if (machine.machine_subtype_code === 'VGG') {
      setTimeout(() => {
        oledResponse('EXITO', '  Retire su producto');
      }, 800);
    }
  }

  const oledsuccessVoid = () => {
    oledComunication(0, '5,0,2,0');
    if (machine.machine_subtype_code === 'VGG') {
      setTimeout(() => {
        oledResponse('EXITO', '  Devolucion realizada con exito');
      }, 500);
    }
  }

  const oledSupport = () => {
    oledComunication(0, '5,0,7,0')
    setAtivityTimer(5)
    if (machine.machine_subtype_code === 'VGG') {
      oledComunication(0, '2,0')
      setTimeout(() => {
        oledComunication(0, '2,1,1,15,30,ERROR DE DESPACHO')
      }, 50);

      setTimeout(() => {
        oledComunication(0, "2,1,1,15,45,Preciona un boton   para ser asistido")
      }, 100);
    }
  }

  const oledFinishConfirmation = () => {

    if (machine.machine_subtype_code === 'VGG') {
      oledComunication(0, '2,0')
      setTimeout(() => {
        oledComunication(0, "2,1,1,10,10,Lee el QR para ver")
      }, 50);

      setTimeout(() => {
        oledComunication(0, "2,1,1,35,20,tu factura")
      }, 100);

      setTimeout(() => {
        oledComunication(0, "2,1,1,25,40,0.Nueva orden")
      }, 150);

      if (voucher_Order != "0") {
        setTimeout(() => {
          oledComunication(0, "2,1,1,25,50,1.Ver voucher")
        }, 200);
      }
    }
  }

  const oledDrop = () => {
    if (machine.machine_subtype_code === 'VGG') {
      oledComunication(0, '5,1,3,0,0,3,200,10000,0')

      setTimeout(() => {
        oledComunication(0, '2,0')
        setTimeout(() => {
          oledComunication(0, '2,1,1,30,30,' + "DESPACHANDO")
        }, 50);

        setTimeout(() => {
          oledComunication(0, '2,1,1,15,40,' + "Espere un momento")
        }, 100);
      }, 500);
    }
  }

  const olederror = (txt, type) => {
    oledComunication(0, '5,1,1,0,0,3,200,10000,0')
    setTimeout(() => { oledComunication(0, '5,0,1,0') }, 200);
    setAtivityTimer(5)
    if (machine.machine_subtype_code === 'VGG') {
      let description = '    Error de pago'
      if (txt != undefined) {
        description = txt
      }

      if (type == true) {
        oledSupport()
      } else {
        setTimeout(() => {
          oledResponse('ERROR', description)

          setTimeout(() => {
            oledScreenPayments()
          }, 1000);
        }, 500);
      }
    }
  }


  const oledQrYappy = (hash) => {

    if (machine.machine_subtype_code === 'VGG') {
      let jsonYappy = [{ "comandaVendType": 3, "vendingCode": "2,3," + hash + ", Yappy QR,  $" + parseFloat(invoiceTotal).toFixed(2) + ", , ,0.CANCELAR" }]


      oledComunication(0, '2,0')
      setTimeout(() => {
        console.log("tengo el hash:" + hash);
        console.log(jsonYappy)
        oledComunication(3, '', jsonYappy)
      }, 50);

      setTimeout(() => {
        inputRefLogYappy.current.focus()
      }, 2000);
    }
  }

  const refresh = () => {

    if (machine.machine_subtype_code === 'VGG') {
      oledComunication(0, '2,0')

      setTimeout(() => {
        oledComunication(0, '2,1,1,35,30,Preparando')
      }, 50);

      setTimeout(() => {
        oledComunication(0, '2,1,1,40,40,Máquina...')
      }, 100);


      setTimeout(() => {
        window.location.reload(true);
      }, 150);

    } else {
      window.location.reload(true);
    }
  }

  const clearShoppingCart = (turnRefresh) => {

    if (turnRefresh == true) {
      refresh()
    }
    clearInterval(intervalNewOrder)
    setItemReadyDispense([]);
    setShowModalDispense(false);
    setReady(false);
    setStatusError(false);
    setShowModalConfirmation(false)
    setNewOrderTemperatureReady(false);
    setNewOrderTemperatureChecking(false);
    setDataNoteCredit(false)

    setVoucher_Order("0")

    setShoppingCart([]);
    setShowModalPayment(false)
    setEventHandlerShoppingCart(1);
    setShowModalPayment(false);
    setStatusScreen(false);
  };

  // Para probar el despacho sin hardware local (vending física) cambia esta constante a `true`
  const bypassLocalDispenseHardware = false;

  const dispense = async (X, Y) => {
    if (bypassLocalDispenseHardware) {
      return { data: { Result: [{ shipresult: 0 }] } };
    }
    return new Promise(async (resolve, reject) => {
      let json = { "nboxid": 1, "x": X, "y": Y }
      try {
        const responseDispense = await RequestLocalFetchAPI.salegoodspro(json)
        resolve(responseDispense);
        return (responseDispense);
      } catch (err) {
        reject(err);
        console.log(err);
      }
    });
  }

  const dispenseAndroid = async (X, Y) => {
    if (bypassLocalDispenseHardware) {
      return { data: { ResultadoDespachado: { totalResult: 0 } } };
    }
    return new Promise(async (resolve, reject) => {
      let dataPosition = {
        "funcion": "DESPACHAR",
        "boxid": 1,
        "datos": [{ "X": X, "Y": Y }],
        "elcspeed": 1,
        "chspeed": 1,
        "price": 1250,
        "goodsnum": 1,
        "ordernumber": getRandomInt(10, 100000)
      }
      try {
        const responseDispense = await VendingAndroidFetchAPI.generalFunctionVending(machine.divices.android_ip, dataPosition)
        resolve(responseDispense);
        return (responseDispense);
      } catch (err) {
        reject(err);
        console.log(err);
      }
    });
  }


  const dispenseSnakky = async (key) => {
    if (bypassLocalDispenseHardware) {
      return { data: {} };
    }
    return new Promise(async (resolve, reject) => {
      try {
        let data = [{ "comandaVendType": 0, "vendingCode": "1," + key }]
        const response = await VendingSnakkyFetchAPI.keypad(data)
        resolve(response);
        return (response);
      } catch (err) {
        reject(err);
        console.log(err);
      }
    });
  }

  const dispenseSnakkyStatus = async (time) => {
    if (bypassLocalDispenseHardware) {
      return { data: { Informacion: "400" } };
    }
    return new Promise(async (resolve, reject) => {
      try {
        let data = [{ "comandaVendType": 0, "vendingCode": "4,0," + time }]
        const responsedata = await VendingSnakkyFetchAPI.getDrop(data)
        resolve(responsedata);
        return (responsedata);

      } catch (err) {
        reject(err);
        console.log(err);
      }
    });
  }


  const updateStockItem = async (group_id, position_id, amount) => {
    console.log("Actualizar la cantidad del producto");
    let item = {
      "group_id": group_id,
      "position_id": position_id,
      "amount": amount
    }

    try {
      const response = await PositionFetchAPI.updatePositionToGroup(machine.id, item, token)
      console.log(response);

      let dataNowGroupsAndPositions = []

      if (localStorage.getItem('GroupsByMachine') != undefined || localStorage.getItem('GroupsByMachine') != '') {
        dataNowGroupsAndPositions = JSON.parse(localStorage.getItem('GroupsByMachine'))
        console.log("intente actualizar el item");

        dataNowGroupsAndPositions.forEach(position => {
          shoppingCart.forEach(group => {
            if (group.position_id === position.position_id) {
              position.amount = amount
            }
          })
        });

        localStorage.setItem("GroupsByMachine", JSON.stringify(dataNowGroupsAndPositions))
      }
    } catch (err) {
      console.log(err);
    }
  }

  const clearStatussentorandlimitDigit = async (data, settingtxt) => {
    try {
      await VendingSnakkyFetchAPI.clearData({ "limit": data, "setting": settingtxt })
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    getPaymentsMethod();
    getdivise();
  }, []);

  useEffect(() => {
    console.log(shoppingCart);
    console.log(invoiceTotal);
    if (shoppingCart.length > 0) {
      setItem({ name: shoppingCart[0].name, price: shoppingCart[0].price, img: shoppingCart[0].img })
    }
  }, [shoppingCart]);

  useEffect(() => {
    setEventDispense(0)
  }, [eventDispense]);

  useEffect(() => {
    let timer = 0
    if (statusRequestYappy == true) {
      timer = setInterval(async () => getYappyTransaction(), 5000);
      return () => clearInterval(timer)
    } else {
      return () => clearInterval(timer)
    }
  }, [statusRequestYappy]);

  // Procesa el resultado de un pago remoto de pinpad, venga por socket (camino normal) o por
  // la consulta de fallback (camino de recuperacion). Dos guardas antes de actuar:
  // 1) el id tiene que ser el del intento de pago EN CURSO - el socket ya valida esto antes de
  //    llamar, pero el fallback solo lo valida antes del await a getPinpadRemotePayment; si un
  //    pago nuevo arranca mientras esa consulta esta en vuelo, sin este chequeo se procesaria
  //    con paymentInfoRef ya apuntando al intento nuevo. Centralizado aca protege a ambos.
  // 2) idempotencia por remote_payment_id: si el mismo id ya fue procesado (evento duplicado,
  //    reconexion, fallback que llega despues del socket, etc.) se ignora.
  const processRemotePaymentResult = (data) => {
    const remotePaymentId = data?._id;

    if (!remotePaymentId || remotePaymentId !== remotePaymentIdRef.current) {
      console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] ignored_stale_for_current_attempt`);
      return;
    }

    if (processedRemotePaymentIdRef.current === remotePaymentId) {
      console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] duplicate_ignored`);
      return;
    }
    processedRemotePaymentIdRef.current = remotePaymentId;

    if (remotePaymentFallbackTimeoutRef.current) {
      clearTimeout(remotePaymentFallbackTimeoutRef.current);
      remotePaymentFallbackTimeoutRef.current = null;
    }

    let EMVStreamResponse = {}
    let description = "Ocurrio un error en el proceso de pago, por favor intente de nuevo"

    if (data?.result?.pinpadResponse) {
      try {
        EMVStreamResponse = JSON.parse(data.result.pinpadResponse)?.EMVStreamResponse
        // Algunas integraciones (ej. tarjeta de credito/pinpad) mandan EMVStreamResponse como
        // un segundo JSON en forma de string (doble-encodeado) en vez de un objeto ya parseado.
        if (typeof EMVStreamResponse === 'string') {
          EMVStreamResponse = JSON.parse(EMVStreamResponse)
        }
        if (!EMVStreamResponse) EMVStreamResponse = {}
      } catch (err) {
        // Si pinpadResponse llega corrupto o con una forma inesperada, no dejamos que el JSON.parse
        // se caiga a mitad de la funcion (eso es lo que trababa la maquina sin avisar).
        console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] pinpad_response_parse_error`, err?.message)
        EMVStreamResponse = {}
      }
    }

    if (data?.status == "completed" && data?.result?.pinpadResponse) {
      description = EMVStreamResponse.responseCodeDescription
      if (typePaymentSelectRef.current == "pay") {
        completedPayment()
      } else {
        voidPay()
      }
    } else {
      description = EMVStreamResponse?.responseCode == "RE" ? EMVStreamResponse?.errorDescription : "Ocurrio un error en el proceso de pago, por favor intente de nuevo"
      cancelPayment();
    }

    function completedPayment() {
      console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] registering_transaction`);
      setDataParamsPaymentVoucher({ authorizationNumber: EMVStreamResponse.authorizationNumber, referenceNumber: EMVStreamResponse.referenceNumber, systemTraceNumber: EMVStreamResponse.systemTraceNumber })
      setVoucher_Order(EMVStreamResponse.voucher);
      setStatusScreen(true);
      setPaymentApproval({ status: 1, description: description });

      setTimeout(() => {
        setShowModalDispense(true);
        registerOrder(paymentInfoRef.current.payment_data.payment_id, EMVStreamResponse, paymentInfoRef.current.payment_data);
        console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] transaction_registered`);

        setShowModalPaymentProcess(false)
        setPaymentApproval({ status: 0, description: "Procesando pago..." })
      }, 1500);
    }

    function cancelPayment() {
      console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] payment_cancelled_or_failed`);
      setStatusScreen(true);
      setPaymentApproval({ status: 2, description: description });

      setTimeout(() => {
        setShowModalPaymentProcess(false)
        setPaymentApproval({ status: 0, description: "Procesando pago..." })
      }, 1500);
    }

    function voidPay() {
      let newVoucher = { EMVStreamResponse: EMVStreamResponse }
      setVoucher_Order(EMVStreamResponse.voucher);
      if (EMVStreamResponse.responseCodeDescription) {
        if (EMVStreamResponse.responseCodeDescription == "APROBADA") {
          registerOrderTempReturn(newVoucher)
        } else {
          ErrorAlert("No se aplico la devolucion.", "Error en la devolucion", "error")
          olederror("Error en la devolucion", false)
        }
      } else {
        ErrorAlert("No se aplico la devolucion.", "Error en la devolucion", "error")
        olederror("Error en la devolucion", false)
      }
    }
  }

  // Se llega aca solo si el socket nunca entrego la confirmacion Y todos los reintentos del
  // fallback tambien fallaron o el pago quedo "pending" indefinidamente. No sabemos con certeza
  // si el banco aprobo el cobro o no - por eso el mensaje pide contactar a soporte en vez de
  // asumir "fallido" y dejar reintentar de inmediato (evita el riesgo de cobrar dos veces si el
  // primer intento si se proceso del lado del banco). Este remote_payment_id queda para
  // reconciliar manualmente via GET /pinpadremotepayment?machine_code=...&business_code=...
  const giveUpOnRemotePayment = (remotePaymentId) => {
    if (processedRemotePaymentIdRef.current === remotePaymentId) return;
    processedRemotePaymentIdRef.current = remotePaymentId;

    console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] fallback_exhausted_unresolved`);

    setStatusScreen(true);
    setPaymentApproval({ status: 2, description: "No pudimos confirmar tu pago." });

    setTimeout(() => {
      setShowModalPaymentProcess(false)
      setPaymentApproval({ status: 0, description: "Procesando pago..." })
    }, 4000);
  };

  // Red de seguridad: si el evento de socket updatedRemotePinPadPayment nunca llega (perdida de
  // conexion, evento emitido antes de que el listener estuviera listo, etc.) consultamos el
  // estado real del pago remoto por HTTP en vez de dejar el flujo esperando indefinidamente.
  // Reintenta con backoff fijo hasta REMOTE_PAYMENT_FALLBACK_MAX_ATTEMPTS veces: un solo intento
  // (version anterior) dejaba la maquina pegada para siempre si ese intento fallaba por algo
  // transitorio (token vencido, blip de red del kiosco, hiccup del backend).
  const checkRemotePaymentFallback = async (remotePaymentId) => {
    if (remotePaymentIdRef.current !== remotePaymentId) return;
    if (processedRemotePaymentIdRef.current === remotePaymentId) return;

    remotePaymentFallbackAttemptsRef.current += 1;
    const attempt = remotePaymentFallbackAttemptsRef.current;

    console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] fallback_poll_started`, { attempt });

    const scheduleRetryOrGiveUp = () => {
      if (remotePaymentIdRef.current !== remotePaymentId) return;
      if (attempt >= REMOTE_PAYMENT_FALLBACK_MAX_ATTEMPTS) {
        giveUpOnRemotePayment(remotePaymentId);
        return;
      }
      remotePaymentFallbackTimeoutRef.current = setTimeout(() => {
        checkRemotePaymentFallback(remotePaymentId);
      }, REMOTE_PAYMENT_FALLBACK_RETRY_DELAY_MS);
    };

    try {
      const response = await PaymentComunicationFetchAPI.getPinpadRemotePayment(remotePaymentId, token);
      const remotePayment = response?.data?.pinpadRemotePayment;

      if (!remotePayment) {
        console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] fallback_poll_empty_response`, { attempt });
        scheduleRetryOrGiveUp();
        return;
      }

      if (remotePayment.status === 'pending') {
        console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] fallback_poll_still_pending`, { attempt });
        scheduleRetryOrGiveUp();
        return;
      }

      console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] fallback_poll_resolved`, { status: remotePayment.status, attempt });
      processRemotePaymentResult(remotePayment);
    } catch (err) {
      console.log(`[VENDING REMOTE PAYMENT][${remotePaymentId}] fallback_poll_error`, { attempt, message: err?.message });
      scheduleRetryOrGiveUp();
    }
  };

  useEffect(() => {
    if (showModalPayment == true) {
      const socket = Socket({ "business_code": business.code, "branchoffice_code": branchoffice.code, "machine_code": machine.code });

      socket.on('updatedRemotePinPadPayment', (response) => {
        const remotePayment = response?.remotePayment;
        const incomingId = remotePayment?._id;

        console.log(`[VENDING REMOTE PAYMENT][${incomingId}] payment_result_received`);

        // Un evento sin id, o con un id que no es el del intento de pago en curso (tardio de
        // un intento anterior, o de otro pago en la misma room), se ignora.
        if (!incomingId || incomingId !== remotePaymentIdRef.current) {
          console.log(`[VENDING REMOTE PAYMENT][${incomingId}] ignored_mismatched_or_stale_event`);
          return;
        }

        processRemotePaymentResult(remotePayment);
      });

      return () => {
        socket.disconnect();
      }
    }
    // Nota: paymentInfo y typePaymentSelect se leen via ref (paymentInfoRef/typePaymentSelectRef)
    // dentro de processRemotePaymentResult. Antes estaban en este arreglo de dependencias, lo que
    // recreaba el socket (desconectando y reconectando, con un socket.id nuevo) justo cuando
    // arrancaba el pago - la causa raiz de por que a veces se perdia updatedRemotePinPadPayment.
  }, [showModalPayment]);



  return (
    <>
      {/* showModalPayment */}
      <Modal
        show={showModalPayment}
        fullscreen
        onHide={() => setShowModalPayment(false)}
        aria-labelledby="vending-payment-modal"
        dialogClassName="vmp-pay-bootstrap-override"
        contentClassName="vmp-pay-bootstrap-override"
      >
        <Modal.Body onClick={() => (inputRefLog.current.focus())}>
          <div className="vmp-pay-root" onClick={() => (inputRefLog.current.focus())}>

            {/* ========== HEADER FIJO ========== */}
            <header className="vmp-pay-header">
              <button
                className="vmp-pay-back"
                onClick={(e) => { e.stopPropagation(); setShowModalPayment(false); clearShoppingCart(true); }}
                aria-label="Volver al carrito"
                title="Volver"
              >
                <i className="uil uil-arrow-left"></i>
              </button>

              <div className="vmp-pay-title">
                <h2>
                  <i className="uil uil-transaction"></i>
                  Pago
                </h2>
              </div>

              <div className="vmp-pay-total-chip" aria-label="Total a pagar">
                <small>Total</small>
                <span><em>$</em>{invoiceTotal.toFixed(2)}</span>
              </div>
            </header>

            {/* ========== BODY (scrollable) ========== */}
            <div className="vmp-pay-body">

              {/* --- Sección: Producto a pagar --- */}
              <section className="vmp-pay-section">
                <span className="vmp-pay-section-label">Producto a pagar</span>

                <div className="vmp-pay-product">
                  <div
                    className="vmp-pay-product-media"
                    onClick={(e) => { e.stopPropagation(); handleShowImg(); }}
                  >
                    <img src={buildCloudinaryImageUrl({url: item.img, width: 300, type: "image", quality: "auto"})} alt={item.name} loading="lazy" />
                  </div>
                  <div className="vmp-pay-product-info">
                    <h3 className="vmp-pay-product-name" title={item.name}>{item.name}</h3>
                    <p className="vmp-pay-product-sub">Listo para dispensar</p>
                  </div>
                </div>

                {/* Modal de cupón preservado tal cual */}
                <ModalCupon
                  getCouponByCode={getCouponByCode}
                  showModalCupon={showModalCupon}
                  setShowModalCupon={setShowModalCupon}
                  actionCupon={actionCupon}
                  randomnumberRemoteValid={randomnumberRemoteValid}
                />

                {/* Totales */}
                <div className="vmp-pay-totals">
                  <div
                    className="vmp-pay-total-row is-discount"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowModalCupon(true);
                      setRandomnumberRemoteValid(getRandomInt(1, 10000));
                    }}
                    title="Aplicar cupón de descuento"
                  >
                    <p className="vmp-pay-total-label">Descuento</p>
                    <p className="vmp-pay-total-amount">$ {invoiceTotalDiscount.toFixed(2)}</p>
                  </div>

                  {taxesArrayAll.map((tax, i) => (
                    tax.total > 0 ? (
                      <div className="vmp-pay-total-row" key={tax.tax_id || i}>
                        <p>Impuesto {tax.tax}</p>
                        <p className="vmp-pay-total-amount">$ {tax.total.toFixed(2)}</p>
                      </div>
                    ) : null
                  ))}

                  <div className="vmp-pay-total-row">
                    <p>Subtotal</p>
                    <p className="vmp-pay-total-amount">$ {parseFloat(item.price).toFixed(2)}</p>
                  </div>

                  <div className="vmp-pay-total-row is-grand">
                    <p>Total</p>
                    <p className="vmp-pay-total-amount">
                      <small>$</small>{invoiceTotal.toFixed(2)}
                    </p>
                  </div>
                </div>
              </section>

              {/* --- Sección: Métodos de pago --- */}
              <section className="vmp-pay-section">
                <span className="vmp-pay-section-label">Métodos de pago</span>
                <div className="vmp-pay-methods-grid">
                  {viewPayment()}
                </div>
              </section>

              {/* Input oculto del escáner — lógica preservada */}
              <input
                id="inputCodeQrDiscount"
                className="vmp-pay-hidden-input"
                ref={inputRefLog}
                inputMode="none"
                type="text"
                onKeyPress={(e) => handleChange(e)}
                autoFocus
              />
            </div>

            {/* ========== FOOTER FIJO ========== */}
            <footer className="vmp-pay-footer">
              <button
                className="vmp-pay-back-2"
                onClick={(e) => { e.stopPropagation(); setShowModalPayment(false); clearShoppingCart(true); }}
                aria-label="Volver al carrito"
                title="Volver"
              >
                <i className="uil uil-arrow-left"></i> Volver
              </button>
              <div className="vmp-pay-footer-hint">
                <i className="uil uil-info-circle"></i>
                Selecciona un método de pago para continuar
              </div>

              <button
                className="vmp-pay-cancel"
                onClick={(e) => { e.stopPropagation(); setShowModalPayment(false); clearShoppingCart(true); }}
              >
                <i className="uil uil-times"></i>
                Cancelar
              </button>
            </footer>

          </div>
        </Modal.Body>
      </Modal>

      {/*Process payment modal*/}
      <Modal
        show={showModalPaymentProcess}
        fullscreen
        onHide={() => setShowModalPaymentProcess(false)}
      >
        <Modal.Body>
          <div className="vmp-status-root">

            <div
              className="vmp-status-halo"
              data-status={
                paymentApproval.status == 1 ? "ok" :
                  paymentApproval.status == 2 ? "err" : "load"
              }
            />

            <header className="vmp-status-header">
              <h2 className="vmp-status-titlebar">
                <i className="uil uil-transaction"></i>
                Pago
              </h2>
              <span className="vmp-status-subtitle">Procesando tu transacción</span>
            </header>

            <div className="vmp-status-body">

              <div className="vmp-status-amount-card">
                <span className="vmp-status-amount-label">Saldo a pagar</span>
                <div className="vmp-status-amount-value">
                  <small>$</small>{invoiceTotal.toFixed(2)}
                </div>
              </div>

              <RenderIf isTrue={dataInfoPaymentSelect == "Yappy"}>
                <div className="vmp-status-yappy-hint">
                  <i className="uil uil-mobile-android-alt"></i>
                  <div>
                    <strong>Yappy activado</strong>
                    <p>Revisa en <b>PENDIENTES</b> de tu app de Yappy</p>
                  </div>
                </div>
              </RenderIf>

              <div
                className="vmp-status-indicator"
                data-status={
                  paymentApproval.status == 1 ? "ok" :
                    paymentApproval.status == 2 ? "err" : "load"
                }
              >
                <RenderIf isTrue={paymentApproval.status == 0}>
                  <div className="vmp-status-loading">
                    <div className="vmp-status-pulse" />
                    <div className="vmp-status-pulse vmp-status-pulse-2" />
                    <svg className="vmp-status-spinner" viewBox="0 0 50 50">
                      <circle className="vmp-status-spinner-track" cx="25" cy="25" r="20" />
                      <circle className="vmp-status-spinner-progress" cx="25" cy="25" r="20" />
                    </svg>
                    <div className="vmp-status-dots">
                      <span></span><span></span><span></span>
                    </div>
                  </div>
                </RenderIf>

                <RenderIf isTrue={paymentApproval.status == 1}>
                  <div className="vmp-status-success">
                    <svg className="vmp-status-check-svg" viewBox="0 0 80 80">
                      <circle className="vmp-status-check-circle" cx="40" cy="40" r="36" />
                      <path className="vmp-status-check-path" d="M 22 42 L 35 55 L 58 28" />
                    </svg>
                    <div className="vmp-status-success-ring" />
                    <div className="vmp-status-success-ring vmp-status-success-ring-2" />
                  </div>
                </RenderIf>

                <RenderIf isTrue={paymentApproval.status == 2}>
                  <div className="vmp-status-error">
                    <svg className="vmp-status-error-svg" viewBox="0 0 80 80">
                      <circle className="vmp-status-error-circle" cx="40" cy="40" r="36" />
                      <path className="vmp-status-error-path vmp-status-error-p1" d="M 28 28 L 52 52" />
                      <path className="vmp-status-error-path vmp-status-error-p2" d="M 52 28 L 28 52" />
                    </svg>
                  </div>
                </RenderIf>

                <div className="vmp-status-legacy-img" aria-hidden="true">
                  <RenderIf isTrue={paymentApproval.status == 1}>
                    <img src={checkImg} alt="" />
                  </RenderIf>
                  <RenderIf isTrue={paymentApproval.status == 2}>
                    <img src={errorImg} alt="" />
                  </RenderIf>
                  <RenderIf isTrue={paymentApproval.status == 0}>
                    <img src={loadingImg} alt="" />
                  </RenderIf>
                </div>
              </div>

              <h3
                className="vmp-status-description"
                data-status={
                  paymentApproval.status == 1 ? "ok" :
                    paymentApproval.status == 2 ? "err" : "load"
                }
              >
                {paymentApproval.description}
              </h3>
            </div>
          </div>

        </Modal.Body>
      </Modal>


      {/* showModalDatos */}
      <Modal
        show={showModalDatos}
        fullscreen
        onHide={() => setShowModalDatos(false)}
        aria-labelledby="example-custom-modal-styling-title">

        <Modal.Body className='m-0 p-0'>
          <main className="vm-root">

            <header className='vm-header'>
              <h2 className="vmp-status-titlebar">
                <i className="uil uil-bill"></i>
                {title}
              </h2>
              <span className="vmp-status-subtitle">Personalizando Factura</span>
            </header>
            <section className='vm-middle'>
              <Keyboard displayKeyboard={displayKeyboard} setDisplayKeyboard={setDisplayKeyboard} />
            </section>
            <footer className='vm-footer'>
              <div className='bd-highlight w-100 row'>
                <div className='col-md-6'><button type="button" className=" vmc-btn-cancel" onClick={() => (setShowModalDatos(false))}>
                  Volver
                </button></div>
                <div className='col-md-6'><button type="button" className=" vmc-btn-pay" onClick={() => (saveDataClient())} >
                  Siguiente
                </button></div>
              </div>
            </footer>
          </main>
        </Modal.Body>
      </Modal>

      <Vendingoutservice showModaloutService={showModaloutService} setShowModaloutService={setShowModaloutService} setEventHandlerMenu={setEventHandlerMenu} clearShoppingCart={clearShoppingCart} status={1} setAtivityTimer={setAtivityTimer}></Vendingoutservice>
      <VendingDispensed itemReadyDispense={itemReadyDispense} showModalDispense={showModalDispense} setShowModalDispense={setShowModalDispense} ready={ready} statusError={statusError} setStatusError={setStatusError} voucher_Order={voucher_Order} dataInfoPaymentSelect={dataInfoPaymentSelect} setEventHandlerMenu={setEventHandlerMenu} order_code_register={order_code_register} clearShoppingCart={clearShoppingCart} voidCreditDebit={voidTypeMachineValid} dataNoteCredit={dataNoteCredit} setDataRutaQr={setDataRutaQr} dataRutaQr={dataRutaQr} shoppingCart={shoppingCart} registerOrderTempReturn={registerOrderTempReturn} inputRefLogDispensed={inputRefLogDispensed} oledSupport={oledSupport} setAtivityTimer={setAtivityTimer}></VendingDispensed>
      <VendingModalConfirmation clearShoppingCart={clearShoppingCart} orderCode={order_code_register} total={invoiceTotal} orderNumber={transaction_code_register} showModalConfirmation={showModalConfirmation} setShowModalConfirmation={setShowModalConfirmation} voucher_Order={voucher_Order} dataInfoPaymentSelect={dataInfoPaymentSelect} setAtivityTimer={setAtivityTimer} refresh={refresh} oledFinishConfirmation={oledFinishConfirmation} inputConfirmation={inputConfirmation} newOrderTemperatureReady={newOrderTemperatureReady} newOrderTemperatureChecking={newOrderTemperatureChecking}></VendingModalConfirmation>
      <VendingModalYappy showModalYappy={showModalYappy} setShowModalYappy={setShowModalYappy} selectPaymentYappy={selectPaymentYappy} paymentValidYappy={paymentValidYappy}></VendingModalYappy>
      <ModalYappyQr paymentInfo={paymentInfo} modalYappyQr={modalYappyQr} setModalYappyQr={setModalYappyQr} dataYappy={dataYappy} setDataHash={setDataHash} dataHash={dataHash} hadleCancelYappy={hadleCancelYappy} invoiceTotal={invoiceTotal} orderNumber={orderNumber} inputRefLogYappy={inputRefLogYappy} handleChangeYappy={handleChangeYappy} oledScreenPayments={oledScreenPayments} ></ModalYappyQr>


      {/* Modal de imagen de prodcto  */}
      <Modal show={showImg} onHide={handleCloseImg} centered>
        <Modal.Header closeButton>
          <Modal.Title>{item.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={buildCloudinaryImageUrl({url: item.img, width: 300, type: "image", quality: "auto"})}
            alt={item.name}
            className='img-pay-meth-modal border-vending-secondary'
            onClick={handleShowImg}
            loading="lazy"
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default VendingMetPayments
